import { AfterViewInit, Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { DocumentEditItemBase } from '../edit-item-base';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiDocumentEditItemSitemapDialogComponent } from '@fi-app/document/edit-item/sitemap-dialog/sitemap-dialog.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-document-edit-item-sitemap-handler',
    template: '',
    standalone: false,
})
export class FiDocumentEditSitemapHandlerComponent
    extends DocumentEditItemBase
    implements AfterViewInit, OnDestroy, OnInit
{
    onClose$ = new Subject<void>();
    onMediaBankFileChanged$ = new Subject<void>();
    onContentChange$ = new Subject<void>();

    constructor(
        injector: Injector,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.onClose$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => this.close());
        this.onMediaBankFileChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(($event) => {
            this.mediaBankFileChangedEmitter.emit($event);
            this.contentChange.emit($event);
        });
        this.onContentChange$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(($event) => this.contentChange.emit($event));
    }

    ngAfterViewInit() {
        this.openSitemapDialog();
    }

    private openSitemapDialog() {
        this.fiDialogsService
            .custom({
                contentComponentRef: FiDocumentEditItemSitemapDialogComponent,
                contentComponentData: {
                    item: this.item,
                    selectedColumn: this.selectedColumn,
                    languageId: this.languageId,
                    onClose$: this.onClose$,
                    onMediaBankFileChanged$: this.onMediaBankFileChanged$,
                    onContentChange$: this.onContentChange$,
                },
                hideDialogTopBorder: true,
                isHeaderDividerShown: true,
                headerText: this.appTextService.get('sitemap.sitemap_widget'),
                yesButtonText: this.appTextService.get('done'),
                config: {
                    panelClass: ['fi-rounded-dialog-panel', 'fi-document-site-map-edit-dialog'],
                    width: '460px',
                    autoFocus: false,
                },
            })
            .afterClosed(() => this.close());
    }

    ngOnDestroy$ = new Subject<void>();

    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
